import type { SVGProps } from "react";

const SvgCreditasLogo = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 46.08 46.08"
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2,
    }}
    {...props}
  >
    <path
      style={{
        fill: "#fff",
      }}
      transform="scale(1.92)"
      d="M0 0h24v24H0z"
    />
    <path
      d="M50.59 37.33c0 3.66-1.48 6.97-3.89 9.37a13.18 13.18 0 0 1-9.36 3.89H1V1h36.35c3.66 0 6.97 1.48 9.36 3.88 2.4 2.39 3.89 5.71 3.89 9.36 0 4.96-2.72 9.27-6.74 11.55 4.02 2.27 6.74 6.6 6.74 11.54z"
      style={{
        fill: "url(#a)",
        fillRule: "nonzero",
      }}
      transform="translate(6.603 6.606)scale(.6371)"
    />
    <path
      d="m34.96 34.97 3.53 3.52a17.92 17.92 0 0 1-12.7 5.25c-9.91 0-17.95-8.04-17.95-17.95S15.88 7.84 25.8 7.84c4.96 0 9.44 2.01 12.7 5.26l-7.05 7.05a7.98 7.98 0 0 0-5.65-2.35c-4.41 0-7.99 3.58-7.99 7.99s3.58 7.99 7.99 7.99c2.2 0 4.2-.9 5.65-2.35l3.52 3.53z"
      style={{
        fill: "url(#b)",
        fillRule: "nonzero",
      }}
      transform="translate(6.603 6.606)scale(.6371)"
    />
    <path
      d="m31.45 31.44 3.52 3.53a12.93 12.93 0 0 1-9.17 3.8c-7.17 0-12.98-5.81-12.98-12.98s5.81-12.97 12.98-12.97c3.58 0 6.82 1.45 9.17 3.8l-3.52 3.52a7.98 7.98 0 0 0-5.65-2.35c-4.41 0-7.99 3.58-7.99 8s3.58 7.99 7.99 7.99c2.2 0 4.2-.9 5.65-2.35z"
      style={{
        fill: "url(#c)",
        fillRule: "nonzero",
      }}
      transform="translate(6.603 6.606)scale(.6371)"
    />
    <defs>
      <linearGradient
        id="a"
        x1={0}
        y1={0}
        x2={1}
        y2={0}
        gradientUnits="userSpaceOnUse"
        gradientTransform="matrix(0 -49.59 49.59 0 25.8 50.59)"
      >
        <stop
          offset={0}
          style={{
            stopColor: "#01579b",
            stopOpacity: 1,
          }}
        />
        <stop
          offset={1}
          style={{
            stopColor: "#4dd0e1",
            stopOpacity: 1,
          }}
        />
      </linearGradient>
      <linearGradient
        id="b"
        x1={0}
        y1={0}
        x2={1}
        y2={0}
        gradientUnits="userSpaceOnUse"
        gradientTransform="matrix(0 -35.9 35.9 0 23.17 43.74)"
      >
        <stop
          offset={0}
          style={{
            stopColor: "white",
            stopOpacity: 1,
          }}
        />
        <stop
          offset={0.28}
          style={{
            stopColor: "#f6f6f6",
            stopOpacity: 1,
          }}
        />
        <stop
          offset={0.73}
          style={{
            stopColor: "#ddd",
            stopOpacity: 1,
          }}
        />
        <stop
          offset={1}
          style={{
            stopColor: "#ccc",
            stopOpacity: 1,
          }}
        />
      </linearGradient>
      <linearGradient
        id="c"
        x1={0}
        y1={0}
        x2={1}
        y2={0}
        gradientUnits="userSpaceOnUse"
        gradientTransform="rotate(-90 31.33 7.44)scale(25.95)"
      >
        <stop
          offset={0}
          style={{
            stopColor: "#ccc",
            stopOpacity: 1,
          }}
        />
        <stop
          offset={0.27}
          style={{
            stopColor: "#ddd",
            stopOpacity: 1,
          }}
        />
        <stop
          offset={0.72}
          style={{
            stopColor: "#f6f6f6",
            stopOpacity: 1,
          }}
        />
        <stop
          offset={1}
          style={{
            stopColor: "white",
            stopOpacity: 1,
          }}
        />
      </linearGradient>
    </defs>
  </svg>
);
export default SvgCreditasLogo;
